export default {
    "created": "Produsul upsell a fost creat cu succes",
    "updated": "Produsul upsell a fost actualizat cu succes",
    "deleted": "Produsul upsell a fost șters cu succes",
    "restored": "Produsul upsell a fost restaurat cu succes",
}
